import { Heading, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const Card = ({ title, description, imageSrc }) => {
  return (
    <VStack
      bg="white"
      color="black"
      borderRadius="lg"
      overflow="hidden"
      spacing={0}
      alignItems="flex-start"
      boxShadow="md"
    >
      {/* Full width image on top */}
      <Image
        src={imageSrc}
        alt={title}
        width="100%"
        height="200px"
        objectFit="cover"
      />

      {/* Content below image */}
      <VStack alignItems="flex-start" spacing={3} p={4}>
        <Heading size="md">{title}</Heading>
        <Text color="gray.600" fontSize="sm">
          {description}
        </Text>
        <HStack spacing={2} color="black">
          <Text fontSize="sm" fontWeight="bold">
            See more
          </Text>
          <FontAwesomeIcon icon={faArrowRight} size="1x" />
        </HStack>
      </VStack>
    </VStack>
  );
};

export default Card;